import { getSubmitFailureMessage, useForm } from "@indietabletop/appkit";
import type { CartProduct } from "../cart/cart";
import { type Product, client } from "../client";

// TODO: Move to AppKit
export function useCheckoutForm(props: {
  products: (CartProduct | Product)[];
  /**
   * The path that will be navigated to if Stripe session is cancelled.
   *
   * If value starts with tilde (~), that character will be replaced with
   * the location origin automatically.
   *
   */
  cancelTo: string;
}) {
  const { products, cancelTo } = props;

  const origin = window.location.origin;
  const successUrl = `${origin}/checkout/sessions/{CHECKOUT_SESSION_ID}`;
  const cancelUrl = cancelTo.replace(/^~/, origin);

  return useForm({
    defaultValues: {},

    async onSubmit() {
      const result = await client.startCheckoutSession({
        products: products.map((p) => {
          return { code: p.code, quantity: "quantity" in p ? p.quantity : 1 };
        }),
        successUrl,
        cancelUrl,
      });

      if (result.isFailure) {
        return result.mapFailure((failure) => getSubmitFailureMessage(failure));
      }

      return result;
    },

    onSuccess(value) {
      // Full redirect to redirect URL.
      window.location.assign(value.redirectTo);
    },
  });
}
